import { Response } from '@/core'
import {
  OrderStatusResponse,
  PackageApiBuilder,
  PackageBaseParams,
  PackageBookingParams,
  PackageBookingResponse,
  PaymentIntentParams,
  PaymentIntentResponse,
  UpdateAnalyticsStatusParams,
  VerifyCartParams,
  VerifyCartResponse,
} from './package.api.types'

export const bookingEndpoints = (builder: PackageApiBuilder) => ({
  verifyCart: builder.query<Response<VerifyCartResponse>, VerifyCartParams>({
    query: ({ params }: VerifyCartParams) => ({
      url: `/package/booking/verify-cart`,
      method: 'get',
      params,
    }),
  }),
  paymentIntent: builder.mutation<Response<PaymentIntentResponse>, PaymentIntentParams>({
    query: ({ params }) => ({
      url: '/package/booking/payment-intent',
      method: 'post',
      params,
    }),
  }),

  packagePreBook: builder.mutation<Response<PackageBookingResponse>, PackageBookingParams>({
    query: ({ params, data }) => ({
      url: '/package/booking/pre-book',
      method: 'post',
      params,
      data,
    }),
  }),

  packageBooking: builder.mutation<Response<PackageBookingResponse>, PackageBookingParams>({
    query: ({ params, data }) => ({
      url: '/package/booking/book',
      method: 'post',
      params,
      data,
    }),
  }),

  securePackageBooking: builder.mutation<Response<PackageBookingResponse>, PackageBookingParams>({
    query: ({ params, data }) => ({
      url: '/package/booking/book/wallet-and-secure-payment',
      method: 'post',
      params,
      data,
    }),
  }),

  bookAffirm: builder.mutation<Response<PackageBookingResponse>, PackageBaseParams>({
    query: ({ sessionId }) => ({
      url: '/package/booking/book/affirm',
      method: 'post',
      params: { sessionId },
    }),
  }),

  getOrderStatus: builder.query<Response<OrderStatusResponse>, PackageBaseParams>({
    query: ({ sessionId }: PackageBaseParams) => ({
      url: `/package/booking/order-status`,
      method: 'get',
      params: { sessionId },
    }),
  }),

  updateAnalyticsStatus: builder.mutation<Response<void>, UpdateAnalyticsStatusParams>({
    query: ({ params, data }) => ({
      url: '/package/booking/analytics-status',
      method: 'put',
      params,
      data,
    }),
  }),
})
